import ScriptsList from './ScriptsList';

export default {
  list: ScriptsList,
};
